var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.8,
    height: 84.802,
    viewBox: "0 0 84.8 84.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(-258.843 -44.393) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M280.567,244.421h16.1c1.368,0,1.881.507,1.882,1.862,0,3.8-.009,7.608.01,11.412a2.059,2.059,0,0,1-.653,1.575q-5.056,5.031-10.093,10.081a1.655,1.655,0,0,1-2.652.023q-11.057-11.045-22.1-22.1a1.619,1.619,0,0,1-.473-1.9,1.6,1.6,0,0,1,1.685-.965C269.7,244.428,275.136,244.421,280.567,244.421Z",
    transform: "translate(-116.942 -0.012)",
    fill: "#f27022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M121.7,262.408q0-8.083,0-16.167c0-1.312.525-1.831,1.847-1.832,3.783,0,7.566.011,11.348-.011a2.188,2.188,0,0,1,1.689.686q4.98,5.017,9.99,10a1.693,1.693,0,0,1,0,2.788q-10.958,10.964-21.921,21.923c-.09.09-.178.182-.275.262a1.567,1.567,0,0,1-1.766.3,1.538,1.538,0,0,1-.919-1.528Q121.7,270.618,121.7,262.408Z",
    transform: "translate(-0.033)",
    fill: "#f27022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M349.988,403.277q0,8.083,0,16.167c0,1.354-.513,1.859-1.884,1.86-3.783,0-7.566-.01-11.348.01a2.127,2.127,0,0,1-1.633-.669q-5.028-5.059-10.08-10.094a1.648,1.648,0,0,1,0-2.649q11.023-11.034,22.053-22.06a1.644,1.644,0,0,1,1.946-.5,1.627,1.627,0,0,1,.949,1.7Q349.975,395.162,349.988,403.277Z",
    transform: "translate(-168.377 -116.947)",
    fill: "#f27022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M139.65,472.808h-16.1c-1.37,0-1.885-.507-1.885-1.858,0-3.8.009-7.607-.01-11.41a2.058,2.058,0,0,1,.649-1.576q5.056-5.029,10.092-10.079a1.673,1.673,0,0,1,2.659-.03q11.056,11.042,22.1,22.1a1.615,1.615,0,0,1-1.211,2.863Q147.8,472.8,139.65,472.808Z",
    transform: "translate(0 -168.451)",
    fill: "#f27022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M232.24,368.485a1.458,1.458,0,0,1-1.187-.489q-5.913-5.914-11.824-11.832a1.566,1.566,0,0,1-.007-2.322q5.924-5.949,11.873-11.872a1.566,1.566,0,0,1,2.323.01q5.926,5.9,11.828,11.827a1.576,1.576,0,0,1,.013,2.37q-5.9,5.926-11.824,11.832A1.46,1.46,0,0,1,232.24,368.485Z",
    transform: "translate(-80.613 -80.616)",
    fill: "#f27022"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockes);
export default __webpack_public_path__ + "static/media/blockes.13c170a7136aafcf8a2804b808fedbf3.svg";
export { ForwardRef as ReactComponent };